import {put,takeLatest,call} from 'redux-saga/effects'
import * as userService from "../../../services/userService"
import {
    SET_VALID_PHONE,
    SET_VALID_PHONE_SUCCESS,
    SET_VALID_PHONE_ERROR
}
    from "../../actions/user"

function* setValidPhoneSaga(action) {
    try {
        const data = yield call(userService.SetValidPhone,action.payload)
        yield put({
            type: SET_VALID_PHONE_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: SET_VALID_PHONE_ERROR,error: error.data
        })
    }
}

export function* setValidPhoneSagaWatcher() {
    yield takeLatest(SET_VALID_PHONE,setValidPhoneSaga)
}